module.exports = __webpack_public_path__ + "static/media/supremeLogo.b0418a6a.svg";